import {Inject, Injectable} from '@angular/core';
import {Store} from "@ngrx/store";
import {BehaviorSubject, Observable, Subject, take} from "rxjs";
import {EntitiesFacade} from "../../../commons/angular/classes/entities-facade";
import {RouteModel} from "../../../routes/models/route.model";
import {RouteMetaDataUpdatedModel} from "../../../routes/models/route-meta-data-updated.model";
import {RoutesActions, RoutesAPiActions, RoutesChannelActions} from "../state/routes.action";
import {routesFeature} from "../state/routes.state";

@Injectable()
export class RoutesFacadeService implements EntitiesFacade<RouteModel> {

  private _panelsRouteIdsMap: BehaviorSubject<any> = new BehaviorSubject({});
  public readonly panelsRouteIdsMap: Observable<any> = this._panelsRouteIdsMap.asObservable();

  private _routeMetaDataUpdated: Subject<RouteMetaDataUpdatedModel> = new Subject<RouteMetaDataUpdatedModel>();
  public readonly routeMetaDataUpdated$: Observable<RouteMetaDataUpdatedModel> = this._routeMetaDataUpdated.asObservable();

  constructor(@Inject(Store) private store: Store<RouteModel>) {
  }

  clearStore(): void {
    this.store.dispatch(RoutesActions.clearStore());
  }

  createOne(entity: RouteModel): void {
  }

  deleteOne(id: string, shouldMask?: boolean): void {
  }

  fetchNext(params?: Object, isSubscribeToChannel?: boolean): void {
    this.store.select(routesFeature.selectCursor()).pipe(take(1)).subscribe((cursor) => {
      if (!!cursor) {
        this.store.dispatch(RoutesAPiActions.getInfiniteScrollRoutes({params: params, isSubscribeToChannel: isSubscribeToChannel}));
      }
    })
  }

  getMany(params?: Object, isSubscribeToChannel?: boolean): void {
    this.store.dispatch(RoutesAPiActions.getRoutes({params: params, isSubscribeToChannel: isSubscribeToChannel}));
  }

  getInfiniteScrollEntities(params?: Object, isSubscribeToChannels?: boolean): void {
    this.store.dispatch(RoutesAPiActions.getInfiniteScrollRoutes({params: params, isSubscribeToChannel: isSubscribeToChannels}));
  }

  getOne(routeId: string, isSubscribeToChannel?: boolean): void {
    this.store.dispatch(RoutesAPiActions.getRoute({routeId: routeId, isSubscribeToChannel: isSubscribeToChannel}));
  }

  removeAll(): void {
    this.store.dispatch(RoutesActions.removeAll());
  }

  removeByIds(ids: string[]): void {
    this.store.dispatch(RoutesActions.removeRoutes({ids: ids}));
  }

  selectOne(id: string) {
    return this.store.select(routesFeature.selectRoute(id));
  }

  selectByIds(ids: string[]): Observable<RouteModel[]> {
    return this.store.select(routesFeature.selectRoutesById(ids));
  }

  selectAll(): Observable<RouteModel[]> {
    return this.store.select(routesFeature.selectRoutes());
  }

  selectInfiniteScrollEntities(): Observable<RouteModel[]> {
    return this.store.select(routesFeature.selectInfiniteScrollRoutes());
  }

  setMany(routes: RouteModel[], isAppendFirst?: boolean): void {
    this.store.dispatch(RoutesActions.setRoutes({routes: routes, isAppendFirst: isAppendFirst}))
  }

  setInfiniteScrollRoutes(routes: RouteModel[], isAppendFirst?: boolean) {
    this.store.dispatch(RoutesActions.setInfiniteScrollRoutesIds({
      routeIds: routes.map(r => r.id),
      isAppendFirst: isAppendFirst
    }));
    this.store.dispatch(RoutesActions.setRoutes({routes: routes, isAppendFirst: isAppendFirst}))
  }

  setOne(entity: RouteModel): void {
  }

  subscribeToChannels(): void {
    this.store.dispatch(RoutesChannelActions.subscribe());
  }

  unsubscribeFromChannels(): void {
    this.store.dispatch(RoutesChannelActions.unsubscribe());
  }

  editOne(id: string, entity: RouteModel): void {
  }

  selectIsLoading(): Observable<boolean> {
    return this.store.select(routesFeature.selectIsLoading());
  }

  updateOne(route: RouteModel): void {
  }

  updateMany(routes: RouteModel[]): void {
  }


  // Routes View
  setPanelRouteIds(panelId: string, routeIds: string[]) {
    const currentPanelRouteIdsMap = this._panelsRouteIdsMap.getValue();
    currentPanelRouteIdsMap[panelId] = routeIds;
    this._panelsRouteIdsMap.next(currentPanelRouteIdsMap);
  }

  removePanelRouteIds(panelId: string) {
    const currentPanelRouteIdsMap = this._panelsRouteIdsMap.getValue();
    delete currentPanelRouteIdsMap[panelId];
    this._panelsRouteIdsMap.next(currentPanelRouteIdsMap);
  }

  getPanelsRouteIdsMap() {
    return this.panelsRouteIdsMap;
  }

  emitRouteMetaDataUpdated(payload: RouteMetaDataUpdatedModel) {
    this._routeMetaDataUpdated.next(payload);
  }

}
